import React, { useRef } from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import { setUidToken } from 'src/helper/tool'
import langM from './lang'
import score from 'src/helper/score'
import cdn from 'src/helper/cdn'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'
import Toast from 'src/component/Toast'
import { apiGetCountDown, apiGetUserRank, apiGetGroupRank, apiGetUserScore, apiExtractReward } from 'src/helper/eidaladha'
// import ReactPlayer from 'react-player'
@inject('store')
@observer
export default class WeekStar extends React.Component {
  constructor(props) {
    super(props)

  }
  state = {
    playstat: 1,
    mp3: 'img/activity/eidaladha/eidaladha.mp3',
    lang: langM.en,
    language: "en",
    ruleStatus: false,
    time: 0,
    toastContent: '',
    current: 1,
    tab: 0,
    playtab: 0,
    ranklength: 0,
    groupRanklength: 0,
    rank: [],
    res: {},
    groupRank: [],
    groupRes: {},

    val: 0,
    extractRecord: [],

    first: {
      avatarurl: '',
      uid: '',
      val: '',
      nickname: ''
    },
    two: {
      avatarurl: '',
      uid: '',
      val: '',
      nickname: ''
    },
    three: {
      avatarurl: '',
      uid: '',
      val: '',
      nickname: ''
    },

    groupfirst: {
      logourl: '',
      dgid: '',
      val: '',
      name: '',
      gid: ''
    },
    grouptwo: {
      logourl: '',
      dgid: '',
      val: '',
      name: '',
      gid: ''
    },
    groupthree: {
      logourl: '',
      dgid: '',
      val: '',
      name: '',
      gid: ''
    },

    uid: '',
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlang(language)
    console.log("language", language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    console.log(uid)
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
    this.setState({ uid: uid })
    this.handleGetRank()
  }

  hideRule = async (status) => {
    this.setState({
      ruleStatus: status
    })
  }


  async handleGetRank() {
    this.setState({ res: await apiGetUserRank() })
    this.handleGetUserRank(0)
    this.setState({ groupRes: await apiGetGroupRank() })
    apiGetCountDown().then((res) => {
      this.setState({ time: res.res })
      if (res.res > 0) {
        this.countDown(res.res)
      }
    }),

      apiGetUserScore().then((res) => {
        this.setState({ val: res.res.val })
        this.setState({ extractRecord: res.res.record })
      })
  }

  countDown = (times) => {
    var timer = null
    timer = setInterval(
      function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          // daystr = day
          daystr = day + 'days '
        }
        //
        this.setState({ time: daystr + hour + ':' + minute + ':' + second })
        times--
      }.bind(this),
      1000
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  async handleGetUserRank(number) {
    this.setState({ tab: number })
    const params = { avatarurl: '', uid: '', nickname: '', val: '' }
    var res = this.state.res
    this.setState({ ranklength: res.res.length })
    if (res.res.length) {
      const [first, two, three, ...rest] = res.res
      this.setState({ first })
      this.setState({ two: two || params })
      this.setState({ three: three || params })
      this.setState({ rank: rest || [] })
      const index = res.res.findIndex((item) => item.uid === this.state.uid)
      if (index !== -1) {
        this.setState({ number: index + 1 })
        this.setState({ user: res.res[index] })
      }
    } else {
      this.setState({ first: params })
      this.setState({ two: params })
      this.setState({ three: params })
      this.setState({ rank: [] })
    }
  }



  async handleGetGroupRank(number) {
    this.setState({ tab: number })
    const params = { logourl: '', dgid: '', name: '', val: '' }
    var res = this.state.groupRes
    this.setState({ groupRanklength: res.res.length })
    if (res.res.length) {
      const [groupfirst, grouptwo, groupthree, ...rest] = res.res
      this.setState({ groupfirst })
      this.setState({ grouptwo: grouptwo || params })
      this.setState({ groupthree: groupthree || params })
      this.setState({ groupRank: rest || [] })
    } else {
      this.setState({ groupfirst: params })
      this.setState({ grouptwo: params })
      this.setState({ groupthree: params })
      this.setState({ grpupRank: [] })
    }
  }
  async play(isPlay) {
    if (isPlay) {
      this.setState({ playtab: 1 })
      this.audioValue.play()
    } else {
      this.setState({ playtab: 0 })
      this.audioValue.pause()
    }
  }

  async autoplay() {
    if (this.state.playstat == 1) {
      this.audioValue.play()
      this.setState({ playstat: 2 })
      this.setState({ playtab: 1 })
    }

  }

  async ExtractReward(id) {
    if (id == 0) {
      return
    }
    apiExtractReward(id).then((res) => {
      if (res.code == 0) {
        this.setState({
          toastContent: 'Suceess'
        })
        apiGetUserScore().then((res) => {
          this.setState({ val: res.res.val })
          this.setState({ extractRecord: res.res.record })
        })
      } else {
        this.setState({
          toastContent: res.msg
        })
      }
    })
    this.refs.toast.hideRule(true)
  }

  renderRank() {
    return (
      <div className={`user-rank-content ${this.state.language == 'ar' ? 'arlang' : ''}`}>
        {this.state.ranklength ? (
          <div className="user-rank-content--rank">
            <div className='user-rank-box' onClick={jumpToUser.bind(this, this.state.two.uid)}>
              <img className="avatar" src="/img/activity/eidaladha/two.png" alt="" />
              <img className="user-avatar" src={cdn(this.state.two.avatarurl)} alt="" />
              <p className="name name1">{this.state.two.nickname}</p>
              <p className="id">{this.state.two.duid}</p>
              <div className="number">{score(this.state.two.val)}</div>
            </div>
            <div onClick={jumpToUser.bind(this, this.state.first.uid)}>
              <img className="avatar av1" src="/img/activity/eidaladha/one.png" alt="" />
              <img className="user-avatar av1" src={cdn(this.state.first.avatarurl)} alt="" />
              <p className="name">{this.state.first.nickname}</p>
              <p className="id">{this.state.first.duid}</p>
              <div className="number">{score(this.state.first.val)}</div>
            </div>
            <div className='user-rank-box' onClick={jumpToUser.bind(this, this.state.three.uid)}>
              <img className="avatar" src="/img/activity/eidaladha/three.png" alt="" />
              <img className="user-avatar" src={cdn(this.state.three.avatarurl)} alt="" />
              <p className="name name1">{this.state.three.nickname}</p>
              <p className="id">{this.state.three.duid}</p>
              <div className="number">{score(this.state.three.val)}</div>
            </div>
          </div>
        ) : null}
        <div className="user-rank-content--list">
          {this.state.rank.map((item, index) => {
            return (
              <div key={item.uid} className="list-item" onClick={jumpToUser.bind(this, item.uid)}>
                <div className="item-rank">
                  <span>{index + 4}</span>
                </div>
                <img className="item-avatar" src={cdn(item.avatarurl)} />
                <div className="item-info">
                  <p>{item.nickname}</p>
                  <p>ID:{item.duid}</p>
                </div>
                <div className="item-number">
                  <span>{score(item.val)}</span>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderGroupRank() {
    return (
      <div className={`user-rank-content ${this.state.language == 'ar' ? 'arlang' : ''}`}>
        {this.state.groupRanklength ? (
          <div className="user-rank-content--rank">
            <div className='user-rank-box' onClick={jumpToRoom.bind(this, this.state.grouptwo.gid)}>
              <img className="avatar" src="/img/activity/eidaladha/two.png" alt="" />
              <img className="user-avatar" src={cdn(this.state.grouptwo.logourl)} alt="" />
              <p className="name name1">{this.state.grouptwo.name}</p>
              <p className="id">{this.state.grouptwo.dgid}</p>
              <div className="number">{score(this.state.grouptwo.val)}</div>
            </div>
            <div onClick={jumpToRoom.bind(this, this.state.groupfirst.gid)}>
              <img className="avatar av1" src="/img/activity/eidaladha/one.png" alt="" />
              <img className="user-avatar av1" src={cdn(this.state.groupfirst.logourl)} alt="" />
              <p className="name">{this.state.groupfirst.name}</p>
              <p className="id">{this.state.groupfirst.dgid}</p>
              <div className="number">{score(this.state.groupfirst.val)}</div>
            </div>
            <div className='user-rank-box' onClick={jumpToRoom.bind(this, this.state.groupthree.gid)}>
              <img className="avatar" src="/img/activity/eidaladha/three.png" alt="" />
              <img className="user-avatar" src={cdn(this.state.groupthree.logourl)} alt="" />
              <p className="name name1">{this.state.groupthree.name}</p>
              <p className="id">{this.state.groupthree.dgid}</p>
              <div className="number">{score(this.state.groupthree.val)}</div>
            </div>
          </div>
        ) : null}
        <div className="user-rank-content--list">
          {this.state.groupRank.map((item, index) => {
            return (
              <div key={item.uid} className="list-item" onClick={jumpToRoom.bind(this, item.gid)}>
                <div className="item-rank">
                  <span>{index + 4}</span>
                </div>
                <img className="item-avatar" src={cdn(item.logourl)} />
                <div className="item-info">
                  <p>{item.name}</p>
                  <p>ID:{item.dgid}</p>
                </div>
                <div className="item-number">
                  <span>{score(item.val)}</span>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  render() {
    let { language, lang } = this.state
    // let {dailyList, monthList,dailyTotal,monthlyTotal} = this.rechargeStore.data
    return (
      <div className="img750">
        <div className={`page-recharge ${this.state.language == 'ar' ? 'arlang' : ''}`} onTouchStart={this.autoplay.bind(this)}>
          <div className="bgA">
            <div className="box0">
              <audio autoPlay ref={(audio) => { this.audioValue = audio; }} src={this.state.mp3}></audio>

              {this.state.playtab == 1 && <img className='play play1' onClick={this.play.bind(this, false)} src='/img/activity/eidaladha/bofang.png' />}
              {this.state.playtab == 0 && <img className='play' onClick={this.play.bind(this, true)} src='/img/activity/eidaladha/zanting.png' />}
              {/* <img className={`play ${this.state.playtab==1 ? 'play1' : ''}`} src='/img/activity/eidaladha/yinyue.png'/> */}
            </div>
            <div className="box1" dangerouslySetInnerHTML={{ __html: lang.content }}></div>
            <div className='box2'>
              <div className='box2-top'>
                <img src="/img/activity/eidaladha/sheep.png"></img>
              </div>
              <div className='box2-top'>
                <img src="/img/activity/eidaladha/gift1.png"></img>
              </div>
              <div className='box2-top'>
                <img src="/img/activity/eidaladha/gift2.png"></img>
              </div>
              <div className='box2-top'>
                <img src="http://img.chatie.live/app/gift/Eidaiadha.png"></img>
              </div>
              {/* <div className='box2-bottom'><img src="/img/activity/eidaladha/sheep.png"></img></div>
            <div className='box2-bottom'><img src="/img/activity/eidaladha/gift1.png"></img></div>
            <div className='box2-bottom'><img src="/img/activity/eidaladha/gift2.png"></img></div> */}
            </div>

            {/* <div className="count-down">
            <div className="count-down--title">{lang.timeR}</div>
            <div className="count-down--time">{this.state.time}</div>
          </div> */}


            {/* ranking */}
            {this.state.current == 1 && <div className='ranking'>
              <div className='rank-title'>
                <div
                  onClick={this.handleGetUserRank.bind(this, 0)}
                  className={this.state.tab === 0 ? 'is-activity' : ''}
                >
                  {lang.individual}
                </div>
                <div
                  onClick={this.handleGetGroupRank.bind(this, 1)}
                  className={this.state.tab === 1 ? 'is-activity' : ''}
                >
                  {lang.room}
                </div>
                <div
                  onClick={() => this.setState({ tab: 2 })}
                  className={this.state.tab === 2 ? 'is-activity' : ''}
                >
                  {lang.rewards}
                </div>
              </div>

              {this.state.tab == 0 && this.renderRank()}
              {this.state.tab == 1 && this.renderGroupRank()}
              {/* 奖励 */}
              {this.state.tab == 2 && <div className='rewards'>
                <div className='rewards-box'>
                  <div className='rewards-box-no'><span>No. 1</span></div>
                  <div className='reward-div'>
                    <div className='reward-div1'>
                      <div><img src="https://img.chatie.live/app/noble/king.png" /></div>
                      <p >14 days</p>
                    </div>
                    <div className='reward-div1 '>
                      <div><img src="/img/activity/eidaladha/gift2.png" /></div>
                      <p className='dyiflag'>{lang.specialgift}</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="img/activity/eidaladha/eio1.png" /></div>
                      <p className='dyiflag2'>Eid al-Adha Medal No. 1 (1 year</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="/img/activity/eidaladha/head.png" /></div>
                      <p>30 days</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img className='dagcar' src="/img/activity/eidaladha/car.png" /></div>
                      <p>30 days</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="/img/activity/recharge/gold.png" /></div>
                      <p className='dyiflag2'>{'IF you spend >2M You will get 300K'}</p>
                    </div>
                  </div>
                </div>


                <div className='rewards-box'>
                  <div className='rewards-box-no'><span>No. 2</span></div>
                  <div className='reward-div'>
                    <div className='reward-div1'>
                      <div><img src="https://img.chatie.live/app/noble/king.png" /></div>
                      <p >7 days</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="img/activity/eidaladha/eio2.png" /></div>
                      <p className='dyiflag2'>Eid al-Adha Medal No. 2 (1 year</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="/img/activity/eidaladha/head.png" /></div>
                      <p>15 days</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="/img/activity/eidaladha/car2.png" /></div>
                      <p>15 days</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="/img/activity/recharge/gold.png" /></div>
                      <p className='dyiflag2'>{'IF you spend >1.5M You will get 200K'}</p>
                    </div>
                  </div>
                </div>

                <div className='rewards-box '>
                  <div className='rewards-box-no'><span>No. 3</span></div>
                  <div className='reward-div'>
                    <div className='reward-div1'>
                      <div><img src="https://img.chatie.live/app/noble/duke.png" /></div>
                      <p >7 days</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="img/activity/eidaladha/eio3.png" /></div>
                      <p className='dyiflag2'>Eid al-Adha Medal No. 3 (1 year</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="/img/activity/eidaladha/head.png" /></div>
                      <p>7 days</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="/img/activity/eidaladha/car2.png" /></div>
                      <p>7 days</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="/img/activity/recharge/gold.png" /></div>
                      <p className='dyiflag2'>{'IF you spend >1M You will get 80K'}</p>
                    </div>
                  </div>
                </div>



                <div className='rewards-box rewards-box1'>
                  <div className='rewards-box-no'><span>Room rewards</span></div>
                  <div className='reward-div'>
                    <div className='reward-div1'>
                      <div><img src="img/activity/eidaladha/room1.png" /></div>
                      <p className='dyiflag2'>Eid al-Adha Room No. 1 (1 year</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="img/activity/eidaladha/room2.png" /></div>
                      <p className='dyiflag2'>Eid al-Adha Room No. 2 (1 year</p>
                    </div>
                    <div className='reward-div1'>
                      <div><img src="img/activity/eidaladha/room3.png" /></div>
                      <p className='dyiflag2'>Eid al-Adha Room No. 3 (1 year</p>
                    </div>
                  </div>
                </div>


              </div>}

            </div>}




            <p className='copyright'>{lang.copyright}</p>

            <Toast language={language} lang={this.state.lang} ref="toast" id="toast" toastContent={this.state.toastContent} />

            {/* 规则页面 */}
            <div className="rules" onClick={this.hideRule.bind(this, true)}>
              {this.state.lang.ruleText}
            </div>

            {this.state.ruleStatus && <div className="loading" onClick={this.hideRule.bind(this, false)}></div>}
            {this.state.ruleStatus && (
              <div className={`popRule animationBeBigCenter`} onClick={this.hideRule.bind(this, false)}>
                <div className={`content ${language == 'ar' && 'arlang'}`} dangerouslySetInnerHTML={{ __html: lang.rule }}>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/eidaladha/index.js